import React from 'react';

import styled from 'styled-components';
import { Button } from '@material-ui/core';
import Ratio from 'react-ratio';
import images from '../assets';
import { MediaQuery } from './Common';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

export const BannerItem = ({ children, onClick }) => {
  return (
    <>
    <MediaQuery min={500}>
      <Ratio ratio={5 / 2} style={{ position: 'relative', cursor: 'pointer' }} onClick={onClick}>
          {children}
      </Ratio>
    </MediaQuery>

    <MediaQuery max={499}>
      <Ratio ratio={5 / 3} style={{ position: 'relative', cursor: 'pointer' }} onClick={onClick}>
          {children}
      </Ratio>
    </MediaQuery>
     
    </>
  );
};

export const BannerTitle1 = ({ children, style = {} }) => {
  return <div style={{ fontFamily: 'NSCJKrB', color: 'white', fontSize: '2vw', ...style }}>{children}</div>;
};

export const BannerTitle2 = ({ children, style = {} }) => {
  return <div style={{ fontFamily: 'GothamB', color: '#ff8a06', fontSize: '4vw', ...style }}>{children}</div>;
};

export const BannerTitle3 = ({ children, style = {} }) => {
  return <div style={{ fontFamily: 'NSCJKrL', color: 'white', fontSize: '2vw', ...style }}>{children}</div>;
};

export const BlockTitle = ({ children }) => {
  return (
    <>
      <MediaQuery min={700}>
        <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 50, textAlign: 'center' }}>{children}</div>
      </MediaQuery>
      <MediaQuery max={699}>
        <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 24, textAlign: 'center' }}>{children}</div>
      </MediaQuery>
    </>
  );
};

export const BlockMore = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1 }}></div>
      <Button onClick={onClick}>
        <img alt="" src={images.icon_plus} />
        <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', marginLeft: 10 }}>{t('more')}</div>
      </Button>
    </div>
  );
};

export const NoticeBar = ({ content, time, onClick }) => {
  return (
    <div style={{ backgroundColor: '#f7f7f7', paddingLeft: 43, paddingTop: 28, paddingBottom: 43, paddingRight: 32 }}>
      <div>
        <div
          style={{
            fontFamily: 'NSCJKrM',
            fontSize: 18,
            color: 'white',
            backgroundColor: '#ff8a06',
            padding: '1.5px 20px',
            borderRadius: 5,
            display: 'inline-block',
          }}
        >
          NOTICE
        </div>
      </div>
      <div style={{ display: 'flex', marginTop: 13, alignItems: 'flex-end' }}>
        <div
          style={{ flex: 1, fontFamily: 'NSCJKrR', fontSize: 18, color: 'black', cursor: 'pointer' }}
          onClick={onClick}
        >
          {content}
          <MediaQuery max={699}>
            <span style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: '#999999', float: 'right' }}>{time}</span>
          </MediaQuery>
        </div>
        <MediaQuery min={700}>
          <span style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: '#999999', float: 'right' }}>{time}</span>
        </MediaQuery>
      </div>
    </div>
  );
};

export const BannerBox = styled.div`
  height: 240px;
  // height: 30vw;
  // max-height: 240px;
  // width: 100%;
  // overflow: hidden;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const BannerTitle = styled.div`
  color: white;
  font-family: 'TimesNRBI';
  font-size: 52px;
`;

export const BannerView = styled.div`
  font-family: 'NSCJKrB';
  font-size: 18px;
  color: black;
  background-color: #f1f1f1;
  display: inline-block;
  border-radius: 50px;
  padding: 6px 35px;
  margin-top: 10px;
  cursor: pointer;
`;

export const BoxCoverImage = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const BoxInImage = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const BoxOver = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  left: 0px;
`;

export const TopDesignTitle = ({ children, title }) => {
  const { t } = useTranslation();
  return (
    <>
      <MediaQuery min={800}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div
            style={{ width: 380, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingLeft: 45 }}
          >
            <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 50, display: 'flex' }}>
              {title}
              <div style={{ fontFamily: 'NSCJKrK', marginLeft: 8, position: 'relative' }}>
                <div style={{ color: 'rgb(0,0,0,0)' }}>TOP5</div>
                <div
                  style={{ backgroundColor: '#ffbc2b', width: '100%', height: 15, position: 'absolute', bottom: 8 }}
                />
                <div style={{ position: 'absolute', top: 0, color: 'black' }}>TOP5</div>
              </div>
            </div>
            <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 50, display: 'flex' }}>{t('designer')}</div>
          </div>
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={799}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 0,
            marginRight: 0,
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              fontFamily: 'NSCJKrR',
              color: 'black',
              fontSize: '6vw',
            }}
          >
            {title}
            <div style={{ fontFamily: 'NSCJKrK', marginLeft: 8, marginRight: 8, position: 'relative' }}>
              <div style={{ color: 'rgb(0,0,0,0)' }}>TOP5</div>
              <div style={{ backgroundColor: '#ffbc2b', width: '100%', height: 15, position: 'absolute', bottom: 8 }} />
              <div style={{ position: 'absolute', top: 0, color: 'black' }}>TOP5</div>
            </div>
            {t('designer')}
          </div>
          {children}
        </div>
      </MediaQuery>
    </>
  );
};

export const TopDesignInfo = ({ photoimg, name, country, destxt, onView }) => {
  return (
    <>
      <MediaQuery min={800}>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: 268, marginRight: 20, display: 'flex', justifyContent: 'flex-end' }}>
            <Ratio
              ratio={1}
              style={{
                width: 268,
                height: 'auto',
                backgroundImage: `url(${photoimg})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            />
          </div>
          <div style={{ flex: 1, paddingLeft: 20, display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              <div style={{ fontFamily: 'NSCJKrB', fontSize: 24, color: 'black' }}>{name}</div>
              <div style={{ fontFamily: 'NSCJKrM', fontSize: 18, color: '#666666', marginLeft: 3 }}>{country}</div>
            </div>
            <div
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 16,
                color: 'black',
                marginTop: 10,
                flex: 1,
                overflow: 'hidden',
                maxHeight: 214,
                display: '-webkit-box',
                WebkitLineClamp: 8,
                textOverflow: 'ellipsis',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {destxt}
            </div>
            <div>
              <div
                style={{
                  fontFamily: 'NSCJKrB',
                  fontSize: 16,
                  color: 'black',
                  cursor: 'pointer',
                  padding: '7px 40px',
                  backgroundColor: 'white',
                  display: 'inline-Block',
                  border: '1px solid black',
                }}
                onClick={() => {
                  onView && onView();
                }}
              >
                VIEW
              </div>
            </div>
          </div>
        </div>
      </MediaQuery>
      <MediaQuery max={799}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20, width: '100%', overflow: 'hidden' }}>
          <div
            style={{
              width: 160,
              marginRight: 10,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Ratio
              ratio={1}
              style={{
                width: 160,
                backgroundImage: `url(${photoimg})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            />
            {/* <img alt='' src={photoimg} style={{ height: 'auto', maxHeight: 180, margin:'auto' }} /> */}
            <div
              style={{
                fontFamily: 'NSCJKrB',
                fontSize: 14,
                color: 'black',
                cursor: 'pointer',
                padding: '4px 20px',
                backgroundColor: 'white',
                display: 'inline-Block',
                border: '1px solid black',
                marginTop: 20,
              }}
              onClick={() => {
                onView && onView();
              }}
            >
              VIEW
            </div>
          </div>
          <div style={{ paddingLeft: 10, display: 'flex', flexDirection: 'column', flex: 1 }}>
            {/* <div style={{ display: "flex", alignItems: "baseline" }}> */}
            <div style={{ fontFamily: 'NSCJKrB', fontSize: 20, color: 'black' }}>{name}</div>
            <div style={{ fontFamily: 'NSCJKrM', fontSize: 16, color: '#666666' }}>{country}</div>
            {/* </div> */}
            <div
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 14,
                color: 'black',
                marginTop: 10,
                flex: 1,
                overflow: 'hidden',
                maxHeight: 220,
                display: '-webkit-box',
                WebkitLineClamp: 7,
                textOverflow: 'ellipsis',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {destxt}
            </div>
          </div>
        </div>
      </MediaQuery>
    </>
  );
};
